module.exports = __webpack_public_path__ + "img/Rotatescreen.b77e0973.svg";